import React, {
  useState,
  useEffect,
} from 'react';

import {
  Icon,
  Popup,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Item = {
  id: number,
  name: string,
};

type Props = {
  activeId: number,
  units: Item[],
  onChange?: { (unit: Item): void },
};

const Units = ({
  units,
  activeId,
  onChange,
}: Props) => {
  if (!units || units?.length < 2) return null;
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    const id = setTimeout(() => {
      if (units.length > 0) {
        setIsOpen(true);
      }
    }, 10);
    return () => {
      clearTimeout(id);
    };
  }, [units[0]?.id]);

  return (
    <Popup
      isOpen={isOpen}
      trigger={(
        <Flex
          flex="0 0 16px"
          justify="flex-end"
          clickable
        >
          <Icon
            type="fa fa-cog"
            color="primary"
          />
        </Flex>
      )}
      preferPlace="above"
      setPopupVisible={() => setIsOpen(!isOpen)}
      handleOuterAction={() => setIsOpen(false)}
    >
      <S.Units>
        {units.map(unit => (
          <S.Item
            key={unit.id}
            onClick={() => {
              onChange(unit);
              setIsOpen(false);
            }}
          >
            <Icon
              type={`far fa${unit.id === activeId ? '-check' : ''}-square`}
              color="primary"
            />
            {unit.name}
          </S.Item>
        ))}
      </S.Units>
    </Popup>
  );
};

Units.defaultProps = {
  onChange: () => {},
};

export default Units;
